// Version de l'application - mise à jour automatiquement lors du build
export const APP_VERSION = '1.0.71';
